import axios from "axios";
var config = require('./config.js');

const api = axios.create({
  baseURL: config.SERVER_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const storedToken = localStorage.getItem("token");

  if (!config.headers.Authorization && storedToken) {
    config.headers.Authorization = `Bearer ${storedToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const businessAccessDenied =
      error?.response?.data?.error === "Business channel access denied";

    if (error?.response?.status === 401 || businessAccessDenied) {
      localStorage.clear();
      window.location.replace("/login");
    }
    return await Promise.reject(error);
  }
);

export default api;
